export function getFirst3UniqueEvents(events) {
  const uniqueEvents = [];
  const seenEventIds = new Set();

  for (const day of events) {
    for (const event of day.events) {
      if (!seenEventIds.has(event.eventId)) {
        uniqueEvents.push(event);
        seenEventIds.add(event.eventId);
        if (uniqueEvents.length === 3) {
          return uniqueEvents;
        }
      }
    }
  }

  return uniqueEvents;
}

export function getCurrentDate() {
  return new Date();
}

export function getDateString(date) {
  return date.toISOString().split('T')[0];
}

export function getEndDate() {
  let date = new Date();
  date.setMonth(date.getMonth() + 3);
  date.setDate(0);

  return date;
}

function getDayOfWeek(date) {
  const daysOfTheWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

  return daysOfTheWeek[date.getDay()];
}

function decodeHtmlEntity(htmlEntity) {
  const textarea = document.createElement("textarea");
  textarea.innerHTML = htmlEntity;

  return textarea.value;
}

function formatTime(timeString) {
  let [hours, minutes] = timeString.split(':');

  hours = parseInt(hours, 10);

  const meridian = hours >= 12 ? 'PM' : 'AM';

  hours = hours % 12;
  hours = hours ? hours : 12;

  if (minutes === '00') {
    return hours + decodeHtmlEntity('&nbsp;') + meridian;
  }

  return hours + ':' + minutes + decodeHtmlEntity('&nbsp;') + meridian;
}

export function formatPromoDate(date) {
  const dayOfWeek = getDayOfWeek(date);
  const month = date.getMonth() + 1;
  const day = date.getDate();

  return `${dayOfWeek}, ${month}/${day}`;
}

export function formatDateTime(startDate, endDate, startTime, endTime) {
  let dateTime = formatPromoDate(new Date(startDate));

  if (endDate && startDate !== endDate) {
    dateTime = dateTime + ' ' + decodeHtmlEntity('&ndash;') + ' ' + formatPromoDate(new Date(endDate));
  }

  if (startTime || endTime) {
    dateTime = dateTime + ' · ';

    if (startTime && endTime && startTime !== endTime) {
      dateTime = dateTime + ' ' + formatTime(startTime) + decodeHtmlEntity('&nbsp;&ndash;&nbsp;') + formatTime(endTime);
    } else {
      dateTime = dateTime + ' ' + formatTime(startTime) + formatTime(endTime);
    }
  }

  return dateTime;
}